import { render } from "./ChargesTab.vue?vue&type=template&id=c6d99f3e&scoped=true"
import script from "./ChargesTab.vue?vue&type=script&lang=js"
export * from "./ChargesTab.vue?vue&type=script&lang=js"

import "./ChargesTab.vue?vue&type=style&index=0&id=c6d99f3e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6d99f3e"]])

export default __exports__